import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';

@Directive({
	selector: '[iconIf]',
	exportAs: 'iconIf',
	standalone: true,
})
export class IconIfDirective {
	// generate a valid unique id for the icon html element iconID<random>
	readonly id: string = 'iconID' + Date.now() + Math.floor(Math.random() * 1000);

	constructor(
		private viewContainer: ViewContainerRef,
		private templateRef: TemplateRef<object>,
	) {}

	// TODO: Skipped for migration because:

	get ref(): HTMLElement {
		const parent = this.templateRef.elementRef.nativeElement?.parentElement;
		return parent?.querySelector(`#${this.id}`);
	}

	//  Accessor inputs cannot be migrated as they are too complex.
	@Input() set iconIf(condition: boolean) {
		if (condition) {
			this.viewContainer.createEmbeddedView(this.templateRef);
			this.templateRef.elementRef.nativeElement.previousSibling.id = this.id;
		} else {
			if (this.ref) {
				this.ref.remove();
			}
		}
	}
}
